/**
 * Daily order cutoff countdown
 */
(function () {
  const SELECTOR = '[data-delivery-order-countdown]';

  function parseConfig(el) {
    return {
      el: el,
      cutoffHour: parseInt(el.getAttribute('data-cutoff-hour'), 10) || 20,
      cutoffMinute: parseInt(el.getAttribute('data-cutoff-minute'), 10) || 0,
      daysBefore: parseInt(el.getAttribute('data-days-before'), 10) || 1,
      daysAfter: parseInt(el.getAttribute('data-days-after'), 10) || 2,
      tomorrowLabel: el.getAttribute('data-tomorrow-label') || 'Tomorrow',
      useWeekday: el.getAttribute('data-use-weekday') !== 'false',
      timeEl: el.querySelector('[data-delivery-countdown-time]'),
      dateEl: el.querySelector('[data-delivery-countdown-date]'),
    };
  }

  function isSameCalendarDay(a, b) {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  function formatDeliveryLabel(config, deliveryDate, now) {
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);

    if (isSameCalendarDay(deliveryDate, tomorrow)) {
      return config.tomorrowLabel;
    }

    if (config.useWeekday) {
      return deliveryDate.toLocaleDateString(undefined, { weekday: 'long' });
    }

    return deliveryDate.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
    });
  }

  function getTodayCutoff(now, hour, minute) {
    const cutoff = new Date(now);
    cutoff.setHours(hour, minute, 0, 0);
    return cutoff;
  }

  function tick(config) {
    if (!config.timeEl || !config.dateEl) return;

    const now = new Date();
    const todayCutoff = getTodayCutoff(now, config.cutoffHour, config.cutoffMinute);
    let activeCutoff = todayCutoff;
    let deliveryOffset = config.daysBefore;

    if (now >= todayCutoff) {
      activeCutoff = new Date(todayCutoff);
      activeCutoff.setDate(activeCutoff.getDate() + 1);
      deliveryOffset = config.daysAfter;
    }

    const diffMs = Math.max(0, activeCutoff.getTime() - now.getTime());
    const hours = Math.floor(diffMs / 3600000);
    const minutes = Math.floor((diffMs % 3600000) / 60000);

    const deliveryDate = new Date(now);
    deliveryDate.setDate(deliveryDate.getDate() + deliveryOffset);
    deliveryDate.setHours(0, 0, 0, 0);

    config.timeEl.textContent = hours + 'h ' + minutes + 'm';
    config.dateEl.textContent = formatDeliveryLabel(config, deliveryDate, now);
  }

  function initCountdown(el) {
    if (!el || el.getAttribute('data-delivery-countdown-ready') === 'true') return;

    const config = parseConfig(el);
    if (!config.timeEl || !config.dateEl) return;

    el.setAttribute('data-delivery-countdown-ready', 'true');
    tick(config);

    if (config.intervalId) window.clearInterval(config.intervalId);
    config.intervalId = window.setInterval(function () {
      tick(config);
    }, 30000);
    el._deliveryCountdownConfig = config;
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(initCountdown);
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
